import {
  prefetchIsStudioAiUser,
  useIsStudioAIUser,
  useIsStudioAIUserQuery,
} from './use-is-studio-ai-user'

/**
 * Returns true if the user is a valid Studio subscriber.
 *
 * NB: Mark this as deprecated and refactor after going live with the new subscription flow.
 */
export const useIsSubscriber = () => {
  return useIsStudioAIUser()
}

export const useIsSubscriberQuery = () => {
  return useIsStudioAIUserQuery()
}

export function getIsSubscriber(): Promise<boolean> {
  return prefetchIsStudioAiUser().catch(() => false)
}
